import loginPrompt from './loginPrompt';
import googleOneTapPrompt from './googleOneTapPrompt';
import abandonCheckout from './abandonCheckout/index';
import { tradeGeneralOnboardingConfig } from './tradeGeneralOnboarding/tradeGeneralOnboardingConfig';
import { privacyPolicyChangeNoticeConfig } from './privacyPolicyChangeNotice/privacyPolicyChangeNoticeConfig';
import tradeRewardsLevelUp from './tradeRewardsLevelUp';
import { tradeVerifyFirmReminderConfig } from './tradeVerifyFirmReminder/tradeVerifyFirmReminderConfig';
import loggedOutTrade from './loggedOutTrade';
import vipCuratedFolder from './vipCuratedFolder';
import semRegistrationPrompt from './semRegistration/semRegistrationPrompt';
import internationalModals from './internationalModals';
import auctionWon from './auctionWon';

export default [
    ...internationalModals,
    ...abandonCheckout,
    loginPrompt,
    googleOneTapPrompt,
    privacyPolicyChangeNoticeConfig,
    tradeGeneralOnboardingConfig,
    tradeRewardsLevelUp,
    tradeVerifyFirmReminderConfig,
    loggedOutTrade,
    vipCuratedFolder,
    semRegistrationPrompt,
    auctionWon,
];
